import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type RouterService from '@ember/routing/router-service';
import type SessionContextService from 'tio-employee/services/session-context';
import type FeaturesService from 'tio-common/services/features';
import type { PersonExtension as PersonModel } from 'tio-data/data/resources/person.ext';

export default class AuthenticatedSlrLrapEnrollmentRoute extends Route {
  @service declare store: Store;
  @service declare router: RouterService;
  @service declare sessionContext: SessionContextService;
  @service declare features: FeaturesService;

  async beforeModel() {
    if (this.features.isDisabled('lrapEnrollment')) {
      this.router.transitionTo('authenticated.slr.dashboard');
      return;
    }

    // TODO: Also redirect already-enrolled users once enrollment state is
    // tracked server-side (e.g. this.sessionContext.currentEmployee?.lrapEnrolledAt).
  }

  async model() {
    const personId = this.sessionContext.person.id;
    if (!personId) {
      throw new Error('Cannot load LRAP enrollment without a person id.');
    }
    const { content } = (await this.store.request(
      findRecord<PersonModel>('person', personId, {
        include: 'email-addresses,postal-addresses',
        reload: true,
      })
    )) as { content: { data: PersonModel } };
    const person = content.data;
    return { person };
  }
}

export interface AuthenticatedSlrLrapEnrollmentRouteModel {
  person: PersonModel;
}
